const notice_routes = {
      path: '/notice',
      name: 'Notice',
      component: () => import('@/components/LayOut/Main'),
      meta: {requiresAuth: true},
      children: [
        {
          path: 'my_send',
          name: 'SendNotice',
          component: () => import('@/views/Notice/SendNotice/SendNotice'),
          meta: {requiresAuth: true},
        },
        {
          path: 'my_get',
          name: 'GetNotice',
          component: () => import('@/views/Notice/GetNotice/GetNotice'),
          meta: {requiresAuth: true},
        },
        {
          path: 'other',
          name: 'OtherNotice',
          component: () => import('@/views/Notice/OtherNotice/OtherNotice'),
          meta: {requiresAuth: true},
        },
        {
          path: 'create',
          name: 'CreateNotice',
          component: () => import('@/views/Notice/CreateNotice/CreateNotice'),
          meta: {requiresAuth: true},
        }
      ]
    }

export default notice_routes;